import { render, staticRenderFns } from "./ProductReferenceModal.vue?vue&type=template&id=7418c8c3&"
import script from "./ProductReferenceModal.vue?vue&type=script&lang=js&"
export * from "./ProductReferenceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports